<template>
  <div class="wrapper">
    <b-input v-model="startHour" maxlength="2"></b-input>
    <b-input v-model="startMinute" maxlength="2"></b-input>
    <b-select v-model="startAmPm" :options="ampm"></b-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Date,
    },
  },
  watch: {
    startMinute(v) {
      this.emit();
    },
    startHour(v) {
      this.emit();
    },
    startAmPm(v) {
      this.emit();
    },
  },
  data() {
    return {
      startHour: null,
      startAmPm: null,
      startMinute: null,
      innerValue: null,
      minutes: [],
      hours: [],
      ampm: [],
    };
  },
  methods: {
    emit() {
      var d1 = new Date(this.value);
      var ds = ` ${d1.getFullYear()}-${d1.getMonth() + 1}-${d1.getDate()} ${
        this.startHour
      }:${this.startMinute}:00 ${this.startAmPm}`;

      var d = this.$moment(ds, "YYYY-MM-DD hh:mm:ss a");

      // is d a valid date
      if (d.isValid()) {
        this.$emit("input", d.toDate());
      }
    },
  },

  created() {
    this.startHour = this.$moment(this.value).format("h");
    this.startMinute = this.$moment(this.value).format("mm");
    this.startAmPm = this.$moment(this.value).format("A");

    for (let i = 1; i < 13; i++) {
      this.hours.push({ text: i, value: i });
    }

    this.minutes.push({ text: "00", value: 0 });
    this.minutes.push({ text: "15", value: 15 });
    this.minutes.push({ text: "30", value: 30 });
    this.minutes.push({ text: "45", value: 45 });

    this.ampm.push({ text: "AM", value: "AM" });
    this.ampm.push({ text: "PM", value: "PM" });
  },
};
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns: 55px 55px 65px;
  grid-gap: 9px;
}
</style>
